import { orderLookupSettingsSchema } from "@redotech/redo-model/order-tracking/tracking-page-definition";
import * as z from "zod";

export const getOrderLookupSettings = {
  name: "getOrderLookupSettings" as const,
  input: z.object({}),
  output: z.object({ settings: orderLookupSettingsSchema.nullable() }),
};
